module.exports = __webpack_public_path__ + "img/logo-etv-large.0689b093.png";